module.exports = __webpack_public_path__ + "static/media/21_A.c315c294.png";